module.exports = __webpack_public_path__ + "static/media/1013611.8dfe9a1c.png";